export { default as bind }                         from './bind'
export { default as capitalize }                   from './capitalize'
export { default as cleanse }                      from './cleanse'
export { default as deepOverride }                 from './deep-override'
export { default as delay }                        from './delay'
export { default as errorCodeMap }                 from '../project-utils/error-code-map'
export { default as failOnHttpError }              from './fail-on-http-error'
export { default as isPresentInAnyOf }             from './is-present-in-any-of'
export { default as pick }                         from './pick'
export { default as remove }                       from './remove'
export { default as memoize }                      from './memoize'
export { default as stopNestedSubmissionBubbling } from './stop-nested-submission-bubbling'
export { default as genFilter }                    from './gen-filter'
export { default as genArgConverter }              from './gen-arg-converter'
export { default as populateObjectUniquely }       from './populate-object-uniquely'
export { default as httpStatusMap }                from './http-status-map'
export { default as unique }                       from './unique'
export { default as unix }                         from './unix'
export { default as downloadExcelFromB64 }          from './downloadExcelFromB64'

import * as regex from './regexps'

export const regexps = regex



// WEBPACK FOOTER //
// ./src/utils/index.ts